var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgICopyAll = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -118.628)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 118.628)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.202 85.006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-14.017,44.888h-5.532a2.084,2.084,0,0,1-2.081-2.08V37.275a2.084,2.084,0,0,1,2.081-2.08h5.532a2.084,2.084,0,0,1,2.081,2.08v5.533A2.084,2.084,0,0,1-14.017,44.888Zm-5.532-8.693a1.083,1.083,0,0,0-1.081,1.08v5.533a1.083,1.083,0,0,0,1.081,1.08h5.532a1.083,1.083,0,0,0,1.081-1.08V37.275a1.083,1.083,0,0,0-1.081-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.856,48.049h-5.531a2.083,2.083,0,0,1-2.081-2.08V44.388a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v1.581a1.081,1.081,0,0,0,1.081,1.08h5.531a1.081,1.081,0,0,0,1.081-1.08V40.437a1.082,1.082,0,0,0-1.081-1.081h-1.58a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1.58a2.084,2.084,0,0,1,2.081,2.081v5.532A2.084,2.084,0,0,1-10.856,48.049Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgICopyAll, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_copy_all.146486e2.svg";
export { ForwardRef as ReactComponent };